@if (isBottomSheet) {
  <mat-action-list>
    @for (paymentOption of paymentOptions; track paymentOption) {
      <div class="option option--sheet">
        <button mat-list-item
          class="option__btn"
          [activated]="!!paymentOption.selected"
          [class.option__btn--selected]="!!paymentOption.selected"
          (click)="!paymentOption.isCustomAmount || paymentOption.error
            ? (item.amountInCart
                ? onClick_updateCartItem(item, paymentOption)
                : onClick_addToCart(item, paymentOption))
            : onClick_showCustomAmount($event)">
          <span matListItemTitle>{{paymentOption.label}}</span>
          @if (!paymentOption.isCustomAmount || paymentOption.error) {
            <span matListItemLine>{{paymentOption.amount | currency}}</span>
          }
        </button>
        @if (paymentOption.isCustomAmount && !paymentOption.error
            && (paymentOption.selected || showCustomAmountField)) {
          <ng-container [ngTemplateOutlet]="customAmountTpl"></ng-container>
        }
      </div>
    }
  </mat-action-list>
} @else {
  <!-- Not a menu (A11Y-029): a custom-amount option renders an inline form on its row, and a form
  cannot be owned by role="menu". mat-menu-item is deliberately NOT used either — its role input
  only accepts menu roles, and its typography/flex rules are scoped to .mat-mdc-menu-content, so
  outside a real panel the rows silently lose their font and their space-between. The enclosing
  role="dialog" panel (search-result.component.html) owns naming and focus containment. -->
  <div class="option-list--menu">
    @for (paymentOption of paymentOptions; track paymentOption) {
      <div class="option option--menu">
        <button type="button" class="option__btn"
          [class.option__btn--selected]="!!paymentOption.selected"
          [attr.aria-pressed]="!!paymentOption.selected"
          (click)="!paymentOption.isCustomAmount || paymentOption.error
            ? (item.amountInCart
                ? onClick_updateCartItem(item, paymentOption)
                : onClick_addToCart(item, paymentOption))
            : onClick_showCustomAmount($event)">
          <div class="option__btn-label">
            <span>{{paymentOption.label}}</span>
            @if (!paymentOption.isCustomAmount || paymentOption.error) {
              <span>{{paymentOption.amount | currency}}</span>
            }
          </div>
        </button>
        @if (paymentOption.isCustomAmount && !paymentOption.error
            && (paymentOption.selected || showCustomAmountField)) {
          <ng-container [ngTemplateOutlet]="customAmountTpl"></ng-container>
        }
      </div>
    }
  </div>
}

<ng-template #customAmountTpl>
  <!-- The click handler only keeps a click inside the form from reaching the option row; it is
  not an action, so it needs no key equivalent. -->
  <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events -->
  <form role="form"
    class="option__form"
    (ngSubmit)="onSubmit_customPaymentAmount()"
    [formGroup]="customAmountForm"
    (click)="$event.stopPropagation()">
    <mat-form-field
      subscriptSizing="dynamic"
      class="select-payment__custom-amount mat-form-field--prefix">
      <input #customAmountInput
        matInput
        name="customAmountInput"
        formControlName="Amount"
        required
        step="0.01"
        placeholder="0.00"
        inputmode="decimal"
        mask="separator.2"
        separatorLimit="1000000000"
        thousandSeparator=","
        [leadZero]="true"
        decimalMarker="."
        [outputTransformFn]="currencyMaskOutput"
        (focus)="onFocusIn_selectText()">
      <span matTextPrefix>$&nbsp;</span>
      <mat-error>{{validationService.getFieldErrorMessage("Amount",
        customAmountForm?.controls?.["Amount"])}}</mat-error>
    </mat-form-field>
    <button matIconButton
      class="option__form-button"
      type="submit"
      aria-label="Apply custom amount">
      <mat-icon>check</mat-icon>
    </button>
  </form>
</ng-template>
